import React, { useRef, useState, useEffect } from 'react';
import BookingModal from './BookingModal';
import Loader from './Loader';
import { optimizeImageUrl } from '@/lib/imageUtils';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const HandpickedDestinations = () => {
  const carouselRef = useRef(null);
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const [selectedDeal, setSelectedDeal] = useState({ title: '', destination: '' });
  const [destinations, setDestinations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/api/handpicked-destinations`)
      .then(res => res.json())
      .then(data => {
        setDestinations(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching handpicked destinations:', err);
        setLoading(false);
      });
  }, []);

  const scrollCarousel = (direction) => {
    if (carouselRef.current) {
      const scrollAmount = carouselRef.current.offsetWidth + 32;
      carouselRef.current.scrollBy({
        left: direction * scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  const handleBookNow = (dest) => {
    setSelectedDeal({ title: dest.title, destination: dest.destination });
    setIsBookingModalOpen(true);
  };

  if (loading) {
    return (
      <section className="handpicked-section" data-testid="handpicked-destinations">
        <div className="handpicked-container">
          <div className="handpicked-header">
            <div className="handpicked-title-wrapper">
              <h2 className="handpicked-title">
                Handpicked Destinations You'll Love
              </h2>
              <div className="handpicked-underline"></div>
            </div>
          </div>
          <Loader />
        </div>
      </section>
    );
  }

  return (
    <section className="handpicked-section" data-testid="handpicked-destinations">
      <div className="handpicked-container">
        {/* Section Header */}
        <div className="handpicked-header">
          <div className="handpicked-title-wrapper">
            <h2 className="handpicked-title">
              Handpicked Destinations You'll Love
            </h2>
            <div className="handpicked-underline"></div>
          </div>
          
          {/* Navigation Controls */}
          <div className="handpicked-nav">
            <button 
              onClick={() => scrollCarousel(-1)} 
              className="handpicked-nav-btn"
              aria-label="Previous"
              data-testid="handpicked-prev"
            >
              <i className="fa-solid fa-chevron-left"></i>
            </button>
            <button 
              onClick={() => scrollCarousel(1)} 
              className="handpicked-nav-btn"
              aria-label="Next"
              data-testid="handpicked-next"
            >
              <i className="fa-solid fa-chevron-right"></i>
            </button>
          </div>
        </div>

        {/* Carousel Container */}
        <div 
          ref={carouselRef}
          className="handpicked-carousel"
          data-testid="handpicked-carousel"
        >
          {destinations.map((dest) => (
            <div key={dest.id} className="handpicked-card">
              {/* Image Area */}
              <div className="handpicked-image-wrapper">
                <img
                  src={optimizeImageUrl(dest.image, 600)}
                  alt={dest.destination}
                  className="handpicked-image"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              
              {/* Content Area */}
              <div className="handpicked-content">
                <div className="handpicked-content-header">
                  <span className="handpicked-tag">{dest.tag}</span>
                  <h3 className="handpicked-card-title">{dest.title}</h3>
                </div>

                <div className="handpicked-highlights">
                  <p className="handpicked-highlights-text">
                    {dest.highlights.join(' • ')}
                  </p>
                </div>

                <button 
                  onClick={() => handleBookNow(dest)}
                  className="handpicked-book-btn"
                  data-testid={`handpicked-book-${dest.id}`}
                >
                  Book Now
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <BookingModal 
        isOpen={isBookingModalOpen}
        onClose={() => setIsBookingModalOpen(false)}
        dealTitle={selectedDeal.title}
        destination={selectedDeal.destination}
      />
    </section>
  );
};

export default HandpickedDestinations;
